export default __webpack_public_path__ + "static/media/041-cooking.236073da.svg";